import Layout from '@/layout'
const jxsShopRouter = {
  path: '/jxs/shop',
  component: Layout,
  name: 'jxsShop',
  meta: {
    title: '授权门店管理',
    icon: 'el-icon-s-shop',
    roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'business']
  },
  children: [

    {
      path: 'create',
      name: 'jxsShopCreate',
      component: () => import('@/views/jxs/shop/shopCreate'),
      meta: { title: '授权门店创建', icon: 'el-icon-plus', roles: ['root', 'business'], noCache: false }
    },
    {
      path: 'edit',
      name: 'jxsShopEdit',
      component: () => import('@/views/jxs/shop/shopUpdate'),
      meta: { title: '授权门店更新', icon: 'el-icon-refrigerator', roles: ['root', 'business'], noCache: false },
      hidden: true
    },
    {
      path: 'table',
      name: 'jxsShopTable',
      component: () => import('@/views/jxs/shop/shopTable'),
      meta: { title: '授权门店列表', icon: 'el-icon-s-unfold', roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'business'], noCache: false }
    }
  ]
}
export default jxsShopRouter
